<div class="row" [formGroup]="formGroup">
  <div class="col-12 col-md-6 d-flex flex-row justify-content-between align-items-start">
    <input type="hidden" formControlName="type">
    <input type="hidden" formControlName="label">
    <mat-form-field class="w-25 me-3" appearance="fill" color="primary">
      <mat-label>Label</mat-label>
      <input type="text"
        placeholder="Pick one"
        matInput
        [formControl]="internalFormControl"
        [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        @for (option of displayTypes; track option) {
          <mat-option [value]="option">
            {{option}}
          </mat-option>
        }
      </mat-autocomplete>
      @if (formGroup.get('type')?.invalid && formGroup.get('type')?.touched) {
        <mat-error>Type is required.</mat-error>
      }
      @if (formGroup.get('label')?.invalid && formGroup.get('label')?.touched) {
        <mat-error>Label is required.</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="flex-spacer" appearance="fill" color="primary">
      <mat-label>Email Address</mat-label>
      <input matInput formControlName="emailAddress" type="text"/>
      @if (formGroup.get('emailAddress')?.hasError('required')) {
        <mat-error>Email address is required.</mat-error>
      }
      @if (formGroup.get('emailAddress')?.hasError('email')) {
        <mat-error>Please enter a valid email address.</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="col-12 col-md-6 d-flex flex-row justify-content-between align-items-start">
    <mat-form-field class="flex-spacer" appearance="fill" color="primary">
      <mat-label>Confirm Email Address</mat-label>
      <input matInput formControlName="emailAddressConfirm" type="text"/>
      @if (formGroup.hasError('duplicateFieldMatchRequired')) {
        <mat-error>Email addresses must match.</mat-error>
      }
    </mat-form-field>
    @if (showDelete) {
      <button mat-icon-button (click)="deleteItem()"><mat-icon>delete</mat-icon></button>
    }
  </div>
</div>
